module.exports = __webpack_public_path__ + "img/26.f5fb204d.png";